import styled from 'styled-components'

import { H3 } from '@/@bothrs-ui/web/components/typography/Heading'

const StSectionTitle = styled(H3)`
  ${({ theme }) => {
    return `
        display: block;
        padding: ${theme.UI.SpacingPx.Space4} 0;
        padding-bottom: ${theme.UI.SpacingPx.Space1};
        position: sticky;
        margin: 0;
        top: 0;
        z-index: 1;
    `
  }}
`

export { StSectionTitle }
